/**
 * Development-only logger that removes console statements in production
 * This ensures no console logs appear in production builds
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const devLog = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  
  table: (...args: any[]) => {
    if (isDevelopment) {
      console.table(...args);
    }
  }
};

// For critical errors that should always be logged (even in production)
// These should be sent to an error tracking service like Sentry
export const criticalError = (message: string, error?: any) => {
  // In production, this would send to Sentry or another error tracking service
  // For now, we'll just ensure it's logged
  console.error(`[CRITICAL] ${message}`, error);
  
  // TODO: Send to error tracking service
  // if (typeof window !== 'undefined' && window.Sentry) {
  //   window.Sentry.captureException(error || new Error(message));
  // }
};